import jsPDF from "jspdf";

// Clinic forms are opened and signed as PDFs (SignDoc, the template list), so
// a form uploaded as a photo or scan is placed on one A4 page first.

const loadImage = blob =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(blob);
    const image = new Image();
    image.onload = () => resolve({ image, url });
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("อ่านไฟล์รูปไม่ได้"));
    };
    image.src = url;
  });

/**
 * @param {Blob} blob - a JPEG or PNG
 * @param {string} name - the original file name; the PDF keeps its stem
 * @returns {Promise<File>} a one-page A4 PDF, oriented like the image
 */
export async function imageToPdf(blob, name) {
  const { image, url } = await loadImage(blob);
  try {
    const width = image.naturalWidth;
    const height = image.naturalHeight;
    const doc = new jsPDF({
      orientation: width > height ? "landscape" : "portrait",
      unit: "pt",
      format: "a4",
      compress: true,
    });
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const scale = Math.min(pageWidth / width, pageHeight / height);
    const drawWidth = width * scale;
    const drawHeight = height * scale;
    doc.addImage(
      image,
      blob.type === "image/png" ? "PNG" : "JPEG",
      (pageWidth - drawWidth) / 2,
      (pageHeight - drawHeight) / 2,
      drawWidth,
      drawHeight,
      undefined,
      "FAST"
    );
    const stem = (name || "form").replace(/\.[^.]+$/, "");
    return new File([doc.output("blob")], `${stem}.pdf`, {
      type: "application/pdf",
    });
  } finally {
    URL.revokeObjectURL(url);
  }
}
